import {
  addPage,
  delPage,
  editPage,
  editPageBaseInfo,
  getEntNavigations,
  getPageDetail,
  setNavHome,
  setNavSort,
  updateNavItem,
  updateNavList
} from '@/services/navigationapi'

export default {
  state: {
    buttombarData: [],
    buttomConfig: ''
  },
  getters: {},
  mutations: {
    setButtombarData (state, array) {
      state.buttombarData = array || []
    },
    setButtomConfig (state, config) {
      state.buttomConfig = config
    }
  },
  actions: {
    getEntNavigations ({commit}) {
      return new Promise((resolve, reject) => {
        getEntNavigations().then(res => {
          let style = ''
          if (res.data.style) {
            style = JSON.parse(res.data.style)
          }
          let config = {
            bgColor: style ? style.bgColor : 'white',
            fontSize: style ? style.fontSize : 24
          }
          commit('setButtomConfig', config)
          let onlineArray = []
          res.data.buttonList.map(child => {
            child.hasRenovation = 1
            child.loadOtherUrl = ''
            onlineArray.push(child)
          })

          commit('setButtombarData', onlineArray)
          resolve(res)
        })
      })
    },
    getPageDetail (store, id) {
      return getPageDetail(id)
    },
    editPageInfo (store, {id, params}) {
      return editPage(id, params)
    },
    updateNavList (store, params) {
      return updateNavList(params)
    },
    addPage (store, params) {
      return addPage(params)
    },
    updateNavItem (store, params) {
      return updateNavItem(params)
    },
    setNavHome (store, id) {
      return setNavHome(id)
    },
    setNavSort (store, params) {
      return setNavSort(params)
    },
    editPageBase (store, {id, params}) {
      return editPageBaseInfo(id, params)
    },
    delPage (store, id) {
      return delPage(id)
    }
  }
}
